import React from 'react';
import { FiAlertTriangle, FiCheckCircle, FiInfo, FiTrendingUp } from 'react-icons/fi';
import { createInsights } from '../reportUtils';

const ICONS = { good: <FiCheckCircle />, warning: <FiAlertTriangle />,
  test: <FiTrendingUp />, info: <FiInfo /> };

const ReportInsights = ({ summary, rows }) => (
  <section className="report-panel report-insights">
    <h2>학습 분석 및 안내</h2>
    <ul>
      {createInsights(summary, rows).map((item, index) => (
        <li key={`${item.tone}-${index}`} className={`is-${item.tone}`}>
          {ICONS[item.tone]}<span>{item.text}</span>
        </li>
      ))}
    </ul>
  </section>
);

export default ReportInsights;

